import React, { Fragment } from 'react';
import PropTypes, { object } from 'prop-types';

import {
  Table,
  DateTime,
  QBRSentiment,
  TableCell,
  TablePerson,
  Comments
} from 'components/common/Elements/Elements';
import Account from '../Account/Account';

import AdditionalFeedBack from '../../parts/AdditionalFeedBack/AdditionalFeedBack';

import { links } from 'data/constants';

import classes from './QbrTable.module.scss';

const { salesforce } = links;

const TableRow = ({
  company,
  tableConf,
  row,
  mouseEnter,
  onOpenAdditionalModal,
  searchText
}) => {
  return (
    <Table.Row className={classes.row}>
      {tableConf.map(({ title, show, field }, ind) => {
        const cellProps = {
          row: row,
          mouseEnter: mouseEnter,
          ind: ind,
          field: field,
          classes: classes
        };
        return (
          <Fragment key={`${title}-${company._id}}`}>
            {show && field === 'companyName' && (
              <TableCell cellProps={cellProps}>
                <Account data={company} searchText={searchText} />
              </TableCell>
            )}
            {show && field === 'nextQbrDate' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.nextQbrDate} time />
              </TableCell>
            )}
            {show && field === 'occurredDate' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.occurredDate} time />
              </TableCell>
            )}
            {show && field === 'opportunityId' && (
              <TableCell cellProps={cellProps} isId>
                {company.opportunityId && company.opportunityId !== 'NA' ? (
                  <a
                    href={`${salesforce}/Opportunity/${company.opportunityId}/view`}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    {company.opportunityId}
                  </a>
                ) : (
                  'NA'
                )}
              </TableCell>
            )}
            {show && field === 'sentiment' && (
              <TableCell cellProps={cellProps}>
                <QBRSentiment sentiment={company.sentiment} />
              </TableCell>
            )}
            {show && field === 'customerFeedback' && (
              <TableCell cellProps={cellProps} isId>
                {(company.customerFeedback !== 'n/a' &&
                  company.customerFeedback !== 'NA') ||
                (company.featureRequest !== 'n/a' &&
                  company.featureRequest !== 'NA') ||
                (company.risk !== 'n/a' && company.risk !== 'NA') ||
                (company.technicalIssues !== 'n/a' &&
                  company.technicalIssues !== 'NA') ||
                (company.useCase !== 'n/a' && company.useCase !== 'NA') ? (
                  <Comments
                    text={company.customerFeedback}
                    data={company}
                    onOpenAdditionalModal={onOpenAdditionalModal}
                    showBtnMorealways
                    searchText={searchText}
                    highlighterTrgiger={[
                      'customerFeedback',
                      'featureRequest',
                      'risk',
                      'technicalIssues',
                      'useCase'
                    ]}
                    BodyModal={AdditionalFeedBack}
                  />
                ) : (
                  'NA'
                )}
              </TableCell>
            )}
            {show && field === 'accountManager' && (
              <>
                {company.accountManager !== 'UnAssigned' ? (
                  <TableCell
                    cellProps={cellProps}
                    classNameContent={classes.center}
                  >
                    <TablePerson
                      person={
                        company.accountManager ? company.accountManager : 'NA'
                      }
                    />
                  </TableCell>
                ) : (
                  <TableCell cellProps={cellProps}>
                    {company.accountManager}
                  </TableCell>
                )}
              </>
            )}
            {show && field === 'customerSuccessEngineer' && (
              <>
                {company.customerSuccessEngineer !== 'UnAssigned' ? (
                  <TableCell
                    cellProps={cellProps}
                    classNameContent={classes.center}
                  >
                    <TablePerson
                      person={
                        company.customerSuccessEngineer
                          ? company.customerSuccessEngineer
                          : 'NA'
                      }
                    />
                  </TableCell>
                ) : (
                  <TableCell cellProps={cellProps}>
                    {company.customerSuccessEngineer}
                  </TableCell>
                )}
              </>
            )}
          </Fragment>
        );
      })}
    </Table.Row>
  );
};

TableRow.propTypes = {
  company: PropTypes.object,
  tableConf: PropTypes.arrayOf(object),
  row: PropTypes.string,
  mouseEnter: PropTypes.func,
  onOpenAdditionalModal: PropTypes.func.isRequired,
  searchText: PropTypes.string
};

export default TableRow;
